import React, { useEffect } from 'react'
import { Text } from '@afterpaytouch/core'
import { Trans } from '../../../../utils/convergence'
import { useTranslation } from '../../../../utils/convergence'
import { useAppDispatch, setConfirmTermsViewed } from '../../../../state'
import { TermLink } from '../../../../component/TermLink/TermLink'
import { TrackingEvent } from '../../../../model/monitoring'
import styles from './styles.module.css'
import { useMonitoringWithEnduringEventProperties } from '../../../../integrations/monitoring'

export const Terms = (): JSX.Element => {
  const { t } = useTranslation()
  const { logEvent } = useMonitoringWithEnduringEventProperties()
  const dispatch = useAppDispatch()
  const termKey = 'summary:terms_appleRetail'

  useEffect(() => {
    dispatch(setConfirmTermsViewed(termKey))
  }, [])

  const components = {
    terms: (
      <TermLink
        key='summary-terms-of-service'
        href={t('common:termsOfServiceUrl')}
        color='Black'
        fontFace={'CashSansMono'}
        onClick={() => logEvent(TrackingEvent.PRESSED_SUMMARY_PAGE_TERMS_LINK, { outboundLink: t('common:termsOfServiceUrl') })}
      />
    ),
  }

  return (
    <div className={styles.container}>
      <Text color='Gray40' size='XXS' fontFace='CashSansMono'>
        <Trans i18nKey={termKey} components={components} />
      </Text>
    </div>
  )
}
